import React from 'react';

/**
 * @returns {JSX.Element} ShareIcon svg
 */
export default function SearchIcon() {
  return (
    <svg
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d={
          'M19.981 26.9743C26.698'
        + ' 24.1196 29.8291 16.3603 26.9744 9.64331C24.1198 2.92633 16.3604'
        + ' -0.204714 9.64343 2.64994C2.92645 5.50459 -0.204592 13.2639 2.65006'
        + ' 19.9809C5.50471 26.6979 13.2641 29.8289 19.981 26.9743Z'
        }
        stroke='#a0a0ab'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M24.1567 24.1562L34.4059 34.4068'
        stroke='#a0a0ab'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>

  );
}
